import React from "react";
import { TableRow, TableCell, Tooltip } from "@mui/material";
import clsx from "clsx";
import style from "@scss/pages/study-center.module.scss";
import { WrapperSVG } from "@components/WrapperSVG/WrapperSVG";
import { NotePencilIcon, TrashIcon } from "@phosphor-icons/react";
import SyncIcon from "@mui/icons-material/Sync";
import { CourseLessonsTableRowPropsT } from "@interfaces/internal-study/courses";
import { getCourseThumbnail } from "@utils/getCompanyLogo";
import { useModal } from "@modals/index";

const InternalStudyСoursesTableRowLessons: React.FC<
  CourseLessonsTableRowPropsT
> = (props) => {
  const { lesson, course, onSyncLesson, onRemoveLesson } = props;
  const { open } = useModal();

  return (
    <TableRow>
      {props.thumbnail && (
        <TableCell>
          {lesson.thumbnail ? (
            <img
              src={getCourseThumbnail(lesson.thumbnail)}
              alt=""
              className={style.courseThumbnail}
            />
          ) : (
            "Не назначено"
          )}
        </TableCell>
      )}
      <TableCell>{lesson.title}</TableCell>
      <TableCell>{lesson.days_disabled}</TableCell>
      <TableCell>{lesson.max_attempts_per_day}</TableCell>
      <TableCell sx={{ px: 1, whiteSpace: "nowrap" }}>
        <Tooltip title="Изменить" placement="top">
          <button
            className={clsx(style.event_item__button)}
            onClick={(e) => {
              e.stopPropagation();
              open("EditInternalCourseLessonModal", {
                btnText: "Сохранить",
                modalData: {
                  id: lesson.id,
                  title: lesson.title,
                  max_attempts_per_day: lesson.max_attempts_per_day,
                  days_disabled: lesson.days_disabled,
                  sync: lesson.sync,
                },
              });
            }}
          >
            <WrapperSVG color="orange" margin>
              <NotePencilIcon size={24} />
            </WrapperSVG>
          </button>
        </Tooltip>
        <Tooltip title="Синхронизировать" placement="top">
          <button
            className={clsx(style.event_item__button)}
            onClick={(e) => {
              e.stopPropagation();
              onSyncLesson(lesson.uuidSDO, course);
            }}
          >
            <WrapperSVG color="green-light" margin>
              <SyncIcon sx={{ display: "block" }} />
            </WrapperSVG>
          </button>
        </Tooltip>
        <Tooltip title="Удалить" placement="top">
          <button
            className={clsx(style.event_item__button)}
            onClick={(e) => {
              if (onRemoveLesson) onRemoveLesson(lesson);
            }}
          >
            <WrapperSVG color="" margin>
              <TrashIcon size={24} />
            </WrapperSVG>
          </button>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default InternalStudyСoursesTableRowLessons;
